var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-quiz__button btn btn-progres",class:{'answered' : _vm.answer.answer != -1 , 'answered-current' : _vm.answer.question == _vm.question},on:{"click":_vm.onClick}},[_c('div',{staticClass:"checkboxHolder"}),_vm._v(" "),_c('div',{staticClass:"btn__content"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98c0a072","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/minigames/matchingquiz/Button.vue
// module id = RkXe
// module chunks = 0